import { useEffect } from "react";
import { translateBackendErrorCode } from "@jti/fe-common";
import { useReferralCustomer, useReferralStatus, useReferralVerifyCode, useUpdateReferralCode } from "@jti/rest-api";
import { useForm } from "../../../components/Form";
import { useUser } from "../../../hooks/useUser";
export const useLoyaltyReferralCode = ({ onCodeApplied = null, verifyErrorMessage, whenHasParentCode = null, source, }) => {
    const { user } = useUser();
    const form = useForm({
        defaultValues: {
            code: "",
        },
    });
    const status = useReferralStatus();
    const customer = useReferralCustomer({ uuid: user?.uuid, ciam_token: user?.ciam_token });
    const verifyCode = useReferralVerifyCode(user);
    const updateReferralCode = useUpdateReferralCode();
    const isSuccess = (updateReferralCode.isSuccess && Boolean(updateReferralCode.data)) || Boolean(customer.data?.parent_code);
    const hideCard = !status.data || status.isLoading || customer.isLoading || customer.data?.has_first_purchase || !user?.uuid;
    const { formState: { errors: { code: codeFormError }, }, } = form;
    const codeCustomErrorMessage = codeFormError?.type === "custom" ? codeFormError.message : null;
    const onSubmit = async () => {
        const referralCode = form.getValues().code.trim();
        try {
            const isValid = await verifyCode.mutateAsync({ referralCode });
            if (isValid) {
                const isApplied = await updateReferralCode.mutateAsync({
                    referralCode,
                    uuid: user?.uuid,
                    ciam_token: user?.ciam_token,
                    source,
                });
                if (isApplied && onCodeApplied) {
                    onCodeApplied();
                }
                if (!isApplied || updateReferralCode.isError) {
                    throw new Error();
                }
            }
            else {
                throw new Error();
            }
        }
        catch (e) {
            const errorMessage = translateBackendErrorCode(e.error_code, verifyErrorMessage);
            form.setError("code", {
                type: "custom",
                message: errorMessage,
            });
        }
    };
    useEffect(() => {
        if (customer.data?.parent_code) {
            form.setValue("code", customer.data.parent_code);
            whenHasParentCode();
        }
    }, [customer.isSuccess]);
    return {
        user,
        form,
        status,
        customer,
        verifyCode,
        updateReferralCode,
        codeFormError,
        onSubmit,
        isSuccess,
        codeCustomErrorMessage,
        hideCard,
    };
};
//# sourceMappingURL=useLoyaltyReferralCode.js.map